export const featureFlag = (feature: string): boolean =>
    typeof window.feature_flag !== 'object' ||
    typeof window.feature_flag[feature] !== 'boolean'
        ? false
        : window.feature_flag[feature];
